module.exports = '<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M16 0c8.836 0 16 7.164 16 16s-7.164 16-16 16S0 24.836 0 16 7.164 0 16 0zm0 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13S23.18 3 16 3zm8.31 10.057l-8.835 8.833a2.082 2.082 0 0 1-2.946 0L8.11 17.475a2.082 2.082 0 0 1 0-2.946 2.082 2.082 0 0 1 2.946 0l2.946 2.946 7.363-7.364a2.082 2.082 0 1 1 2.944 2.946z" fill="#6DBA65" fill-rule="evenodd"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/outline-success-1.js
// module id = 1324
// module chunks = 14